import { render, staticRenderFns } from "./ResourceEntity.vue?vue&type=template&id=3e5f00c1&scoped=true&"
import script from "./ResourceEntity.vue?vue&type=script&lang=ts&"
export * from "./ResourceEntity.vue?vue&type=script&lang=ts&"
import style0 from "./ResourceEntity.vue?vue&type=style&index=0&id=3e5f00c1&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5f00c1",
  null
  
)

export default component.exports